import { Flex,Image,Button} from '@aws-amplify/ui-react';
import logo from '../Logo.png';
import '../styles/navbar.css';

/*
 * Componente de barra de navegación   
 * @param {signOut} función de cerrar sesion del autenticador
 * @returns Estructura de la navegación de la pagina inicial.
 */
function Navbar({signOut}){
    return (
        <Flex
            height="10%"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            padding="0px 5%"
            className='navBar'
            backgroundColor="#282c34"
        >
            <Image
            alt="Ailanto Logo"
            src={logo}
            height="15vmin"
            opacity="100%"
            />
            <Button
                id="botonLogOut"
                onClick={signOut}
                height="20%"
                color="white"
            >
                Cerrar Sesión
            </Button>
        </Flex>
    );
}

export default Navbar;